import fetcher from "../../../helper/fetcher";
import React, { useEffect, useState } from 'react';
import { useSnackbar } from '../../../context/SnackBarContext';
import { ManageIndiractSalesUI } from "../../../features/Inventory/PuchaseOrderUI/ManageIndiractSales/ManageIndiractSales";

export const ManageIndiractSales = () => {
  const { showSuccess, showError } = useSnackbar();
  const [refetch, setRefetch] = useState(1);
  const [invoices, setInvoices] = useState({
    results: [],
    page: 0,
    limit: 0,
    totalPages: 0,
    totalResults: 0,
  });
  const [isLoading, setLoading] = useState(false);
  const [state, setState] = useState({
    id: null,
    isModalOpen: false,
    query: "",
  });
  const [params, setParams] = useState({
    page: 1,
    limit: 20,
  });

  const setPage = (page) => {
    setParams({ ...params, page: page });
  };

  const updateState = (data) => {
    setState((prevState) => {
      return { ...prevState, ...data };
    });
  };

  const handleSearchInvoice = (val) => {
    fetcher
      .get(
        `/inventory/indirect_sale/getAll_indirect_sale?query=${state.query}&page=${val === undefined ? params.page : val}&limit=${params.limit}`
      )
      .then((res) => {
        setLoading(true);
        setInvoices({ ...res.data });
      })
      .catch((err) => {
        showError("Failed to fetch Indirect Sales");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleSearchInvoice();
  }, [refetch, params]);

  const handleDeleteInvoice = () => {
    if (!state.id) return;
    updateState({ isLoading: true });
    fetcher
      .delete(`/inventory/indirect_sale/delete_indirect_sale/${state.id}`)
      .then((res) => {
        showSuccess("Deleted successfully");
      })
      .catch(() => {
        showError("Some Error Occurred");
      })
      .finally(() => {
        setRefetch((pre) => pre + 1);
        updateState({ isLoading: false, isModalOpen: false });
      });
  };

  return (
    <ManageIndiractSalesUI
      invoices={invoices}
      updateState={updateState}
      isLoading={isLoading}
      state={state}
      setPage={setPage}
      setRefetch={setRefetch}
      handleDeleteInvoice={handleDeleteInvoice}
      handleSearchInvoice={(val) => handleSearchInvoice(val)}
    />
  );
};

